export default {"src":"/_next/static/media/x-icon.9f6946f7.svg","height":28,"width":29,"blurWidth":0,"blurHeight":0};